<app-header></app-header>

<div class="flex mt-2">
  <app-sidebar optionMenu="7"></app-sidebar>

  <div class="flex cursor-pointer absolute top-[90px] left-[275px]" [routerLink]="['/ia']">
      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
          <path d="M8 15L1 8L8 1" stroke="#3C00A3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <p class="relative left-2 bottom-1">ATRAS</p>
  </div>

  <div class="bg-white rounded-2xl shadow-md mx-auto mt-8 w-[47%] h-3/4 flex flex-col">
    
    <div class="p-10">
      <h1 class="text-2xl font-bold leading-8 mb-10">Versionador de artículos</h1>
     
      <form [formGroup]="formUrl">
        
        <label class="block text-base text-dark-light mb-3" for="url1">*URL del artículo 1</label>
        <input type="text" class="h-12 mt-1 pl-3 block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm bg-light-light" id="url1" formControlName="url1" placeholder="URL">
      
        <label class="block text-base text-dark-light mb-3" for="url2">*URL del artículo 2</label>
        <input type="text" class="h-12 mt-1 pl-3 block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm bg-light-light" id="url2" formControlName="url2" placeholder="URL">

        <label class="block text-base text-dark-light mb-3" for="url3">*URL del artículo 3</label>
        <input type="text" class="h-12 mt-1 pl-3 block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm bg-light-light" id="url3" formControlName="url3" placeholder="URL">

        <label class="block text-base text-dark-light mb-3" for="url4">*URL del artículo 4</label>
        <input type="text" class="h-12 mt-1 pl-3 block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm bg-light-light" id="url4" formControlName="url4" placeholder="URL">

        <div class="flex flex-col gap-3 mt-6">
          <p class="font-bold text-lg">*Selecciona el LLM para generar la vesión</p>
          <label *ngFor="let option of options" class="flex items-center gap-3 cursor-pointer">
            <input type="radio"
                   [value]="option.value"
                   formControlName="nombreIA"
                   class="accent-blue-600 w-4 h-4" />
            <img [src]="option.image" class="w-28 h-8" />
          </label>
        </div>


        <button (click)="sendUrl()" type="submit" class="w-44 h-10 font-bold py-2 px-4 mt-6 rounded-md hover:bg-green-700 flex items-center bg-green-700">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 5V19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span class="text-white font-semibold text-sm pl-3">Generar versión</span>
        </button>
      
      </form>
    </div>  
 
  </div> 

  <div class="w-1/3 bg-white p-8 rounded-lg shadow mt-8">
    <form novalidate>
      
      <h2 class="text-xl font-bold mb-4">Nuevo prompt</h2>
      <textarea [(ngModel)]="explorerPrompt" name="prompt" rows="6" class="w-full p-2 border border-gray-300 rounded-md mb-4 whitespace-pre-line"
        placeholder="Ingresa un nuevo prompt aquí..."></textarea>
  
      <button (click)="explorerVersionPrompt()" type="submit" class="w-44 h-10 font-bold py-2 px-4 rounded-md hover:bg-green-700 bg-green-700 text-white">Enviar</button>
    </form>
  </div>
  

</div>  
